import { Slide } from "@jelly/lesson";
import config from "appConfig";

import { task as task03 } from "../../../../../task/course-04/lesson-27/task-03";

const task: Slide = {
  titleHtml: `The figure below shows the directivity pattern of a linear array calculated with a "delay and sum"<br>processing  for f = 252 Hz and d = 10 cm. Using the first null angle, calculate the number of microphones.`,
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [4, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/04/27/task/task-3.svg`,
                },
              },
              styles: {
                padding: "3%",
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task03.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
